import ContainerValidation from "../Components/ContainerValidation";
import HeaderValidation from "../Components/HeaderValidation";
import routes from "../../../../../Routes/routes";
import BodyValidation from "../Components/BodyValidation";
import React, {useEffect} from "react";
import {useParams} from "react-router-dom";
import {useTranslation} from "react-i18next";
import {IconDocumentationValidation} from "../../../../../components/buttons/IconButtons";
import useForbiddenValidation from "../Functionality/useForbiddenValidation";
import {useDispatch, useSelector} from "react-redux";
import {GetInvitationById} from "../../../../../reduxToolkit/Invitation/InvitationApi";
import {getUrlParameters} from "../Model/Model";

/**
 * @Email : azapata@ibl.mx
 * @Author: Ferro Zapata Arnulfo
 * @jobTittle: Full Stack Developer
 *
 */
const DocumentationValidation = () => {
    const { id, guardFlowId } = useParams();
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { getInvitationById } = useSelector((state) => state.InvitationSlice);
    const invitationId = getInvitationById?.invitation?.id;

    /**
     * retrieves data from the invitation
     */
    useEffect(() => {
        if (id && id !== invitationId) {
            dispatch(GetInvitationById(id));
        }
    }, [id, invitationId, dispatch]);

    useForbiddenValidation({ getInvitationById, documentationFlow: true });

    return (
        <ContainerValidation>
            <HeaderValidation url={getUrlParameters({ url:routes.invitationDetails.registrationProcess, id, guardFlowId })}/>

            <BodyValidation url={getUrlParameters({ url: routes.invitationDetails.createDocumentary, id, guardFlowId })}>
                <>
                    <div className="row">
                        <div className="col-12 d-flex flex-column justify-content-center align-items-center">
                            <p className="fs-24-to-18 ibl-font-w-600 font-color-general-950">{t("visitor_documentation")}</p>
                            <p className="fs-20-to-14 ibl-font-w-400 font-color-general-950 text-center">
                                { guardFlowId ? t("to_confirm_the_visit_the_visitors_documents_need_collected") : t("documentation_validation_subtitle")}
                            </p>
                        </div>
                    </div>

                    <div className="d-flex justify-content-center align-items-center pt-3">
                        <div className="icon-identity-validation-container">
                            <IconDocumentationValidation className="w-100 h-100" />
                        </div>
                    </div>

                </>
            </BodyValidation>
        </ContainerValidation>
    )

}


export default DocumentationValidation
